// Core
import ROUTES from "@constants/routing";
import { useKeycloakAdmin, useWavesTabsConfig } from "@hooks";
import ViewAdminPanel from "@views/ViewAdminPanel";
import ViewFallback from "@views/ViewFallback";
import ViewHome from "@views/ViewHome";
import ViewMMModel from "@views/ViewMMModel";
import ViewSimulator from "@views/ViewSimulator";
// Routing
import { BrowserRouter, Route, Routes } from "react-router-dom";
// Hooks
// Views

const Router = () => {
  const hasKeycloakAdmin = useKeycloakAdmin();
  const tabs = useWavesTabsConfig();

  return (
    <BrowserRouter>
      <Routes>
        <Route key="home" path={ROUTES.HOME} element={<ViewHome />} />
        {tabs
          .filter((tab) => tab.id === "modeling")
          .map((tab) => (
            <Route key={tab.id} path={tab.path} element={<ViewMMModel />} />
          ))}
        {tabs
          .filter((tab) => tab.id === "simulator")
          .map((tab) => (
            <Route key={tab.id} path={`${tab.path}/*`} element={<ViewSimulator />} />
          ))}
        {hasKeycloakAdmin && (
          <Route
            key="admin-panel"
            path={`${ROUTES.ADMIN_PANEL}/*`}
            element={<ViewAdminPanel />}
          />
        )}
        <Route
          key="not-found"
          path="*"
          element={<ViewFallback variant="not-found" />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
